import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../fopForm/Fop.css";
import { Typography, Button, Radio, Checkbox } from '@mui/material';
import { useAuth } from '../auth/Auth';
import { useNavigate } from 'react-router-dom';

const Fop = () => {
  const [contractor, setContractor] = useState(null);
  const [contractorRestaurants, setContractorRestaurants] = useState([]);
  const [contractorType, setContractorType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRestaurant, setSelectedRestaurant] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [showPackageForm, setShowPackageForm] = useState(false);
  const [showChangeContractorForm, setShowChangeContractorForm] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedFop, setSelectedFop] = useState(null);
  const [expandedFops, setExpandedFops] = useState({});
  const [fopDetails, setFopDetails] = useState({});
  const [packageUpdateStatus, setPackageUpdateStatus] = useState('');
  const [packageHistory, setPackageHistory] = useState(null);
  const [addFopStatus, setAddFopStatus] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isInvalidFop, setIsInvalidFop] = useState(false);
  const [showInvalidFopMessage, setShowInvalidFopMessage] = useState(false);
  const [extractData, setExtractData] = useState({ fop: '', edrpou: '' });
  const [showSuccessContainer, setShowSuccessContainer] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [deactivatedFopName, setDeactivatedFopName] = useState(null);
  const [currentFopCount, setCurrentFopCount] = useState(0);
  const [contractorEmails, setContractorEmails] = useState([]);
  const [creditConfig, setCreditConfig] = useState({ edrpou: "", status: "0" });
  const [creditConfigActive, setCreditConfigActive] = useState(false);
  
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const translations = {
    rest: "Ресторани",
    actvFop: "Активні ФОП",
    client: "Клієнт",
    pac: "Пакет",
    collapse: "Згорнути",
    moreDetail: "Деталі",
    ederpou: "ЄДРПОУ",
    basic: "Базовий",
    start: "Старт",
    pro: "Професійний",
    exclusive: "Ексклюзивний"
  };

  useEffect(() => {
    fetchContractorData();
    if (contractorRestaurants.length > 0) {
      setSelectedRestaurant(contractorRestaurants[0].name);
    }
  }, [user, contractorRestaurants]);

  const fetchContractorData = async () => {
    try {
      const userId = user?.user_id;
      if (!userId) {
        setError('Користувач не авторизований');
        setLoading(false);
        return;
      }
  
      const [contractorResponse, typeResponse, restaurantsResponse] = await Promise.all([
        axios.get(`https://bank2.daolog.net/user-contractor-eee/${userId}`),
        axios.get(`https://bank2.daolog.net/user-contractor-type-eee/${userId}`),
        axios.get(`https://bank2.daolog.net/user-contractor-restaurants-eee/${userId}`)
      ]);

      setContractor(contractorResponse.data);
      setContractorType(typeResponse.data.type);
      setContractorRestaurants(restaurantsResponse.data);
      setSelectedPackage(contractorResponse.data.pac);

      // Отримання конфігу кредиту для контрактора
      try {
        const creditConfigResponse = await axios.get(`https://bank2.daolog.net/api/credit-config/${contractorResponse.data.id}`);
        if (creditConfigResponse.data && creditConfigResponse.data.length > 0) {
          setCreditConfig(creditConfigResponse.data[0]);
          setCreditConfigActive(creditConfigResponse.data[0].status === "1");
        }
      } catch (error) {
        console.log('Credit config not found or error fetching it');
      }

      await fetchContractorEmails(contractorResponse.data.id);
    
      const totalFops = restaurantsResponse.data.reduce((total, restaurant) => {
        return total + restaurant.fops.filter(fop => !fop.name_fop.includes('_deactivated')).length;
      }, 0);
      setCurrentFopCount(totalFops);
      
      setLoading(false);
    } catch (error) {
      console.error('Error fetching contractor data:', error);
      setError('Помилка при отриманні даних');
      setLoading(false);
    }
  };

  const fetchContractorEmails = async (contractorId) => {
    try {
      const response = await axios.get(`https://bank2.daolog.net/contractor-emails-list-eee/${contractorId}`);
      setContractorEmails(response.data);
    } catch (error) {
      console.error('Error fetching contractor emails:', error);
    }
  };

  const toggleFopDetails = async (fopId) => {
    setExpandedFops(prev => ({
      ...prev,
      [fopId]: !prev[fopId]
    }));

    if (!fopDetails[fopId] && !expandedFops[fopId]) {
      try {
        const response = await axios.get(`https://bank2.daolog.net/fop-eee/${fopId}`);
        setFopDetails(prev => ({
          ...prev,
          [fopId]: response.data
        }));
      } catch (error) {
        console.error('Error fetching FOP details:', error);
      }
    }
  };

  const handleFopSelect = (fopId) => {
    setSelectedFop(fopId);
  };

  const getAvailablePackages = () => {
    const chainPackages = [
      { label: translations.basic, value: 'BASIC', limit: 3 },
      { label: translations.start, value: 'START', limit: 10 },
      { label: translations.pro, value: 'PRO', limit: 20 },
      { label: translations.exclusive, value: 'EXCLUSIVE', limit: 50 }
    ];

    const regularPackages = [
      { label: translations.basic, value: 'BASIC', limit: 3 },
      { label: translations.start, value: 'START', limit: 10 },
      { label: translations.pro, value: 'PRO', limit: 20 },
      { label: translations.exclusive, value: 'EXCLUSIVE', limit: 50 }
    ];

    return contractorType === 'chain' ? chainPackages : regularPackages;
  };

  const handleAddNewFop = () => {
    if (contractorRestaurants.length > 0) {
      setSelectedRestaurant(contractorRestaurants[0].name);
    }
    setShowAddForm(true);
    setShowPackageForm(false);
    setShowChangeContractorForm(false);
    setShowSuccessContainer(false);
  };

  const handleChangeContractor = () => {
    if (contractorRestaurants.length > 0) {
      setSelectedRestaurant(contractorRestaurants[0].name);
    }
    setShowChangeContractorForm(true);
    setShowPackageForm(false);
    setShowAddForm(false);
    setShowWarning(false);
    setShowUploadForm(false);
  };

  const handlePackageChange = () => {
    setShowPackageForm(true);
    setShowAddForm(false);
    setShowChangeContractorForm(false);
    setPackageUpdateStatus('');
  };

  const handleClose = () => {
    setShowAddForm(false);
    setShowPackageForm(false);
    setShowSuccessContainer(false);
    setShowChangeContractorForm(false);
    setSelectedPackage(null);
    setPackageUpdateStatus('');
    setPackageHistory(null);
    setShowSuccessMessage(false);
    setShowInvalidFopMessage(false);
    setShowWarning(false);
    setShowUploadForm(false);
  };

  const handlePackageSelect = (packageValue) => {
    setSelectedPackage(packageValue);
    setPackageUpdateStatus('');
  };

  const handleUpdatePackage = async () => {
    const selectedPacOption = getAvailablePackages().find(option => option.value === selectedPackage);
    const currentPacOption = getAvailablePackages().find(option => option.value === contractor?.pac);
    const isDowngrade = selectedPacOption.limit < currentPacOption.limit;
    
    try {
      const response = await axios.put(`https://bank2.daolog.net/update-package-eee/${contractor.id}`, {
        newPac: selectedPackage,
        newFopAmount: selectedPacOption.limit,
        userId: user.user_id,
        isDowngrade
      });
      
      setPackageHistory({
        oldPac: response.data.oldPac,
        changeDate: new Date(response.data.changeDate).toLocaleDateString()
      });
      
      setShowSuccessContainer(true);
      setShowPackageForm(false);
      fetchContractorData();
    } catch (error) {
      if (error.response?.data?.error === 'date_restricted') {
        setPackageUpdateStatus(error.response.data.message);
      } else if (error.response?.data?.error === 'downgrade_restricted') {
        setPackageUpdateStatus('Зміна на менший пакет можлива тільки з початку наступного місяця');
      } else {
        setPackageUpdateStatus('Помилка при зміні пакету');
      }
    }
  };

  const handleCreditConfigChange = async (e) => {
    const isActive = e.target.checked;
    setCreditConfigActive(isActive);
    
    const newConfig = {
      edrpou: creditConfig.edrpou,
      status: isActive ? "1" : "0"
    };
    
    setCreditConfig(newConfig);
    
    try {
      await axios.post(`https://bank2.daolog.net/api/update-credit-config`, {
        contractorId: contractor.id,
        config: [newConfig]
      });
    } catch (error) {
      console.error('Error updating credit config:', error);
    }
  };

  const handleEdrpouChange = async (e) => {
    const newEdrpou = e.target.value;
    
    const newConfig = {
      edrpou: newEdrpou,
      status: creditConfig.status
    };
    
    setCreditConfig(newConfig);
    
    try {
      await axios.post(`https://bank2.daolog.net/api/update-credit-config`, {
        contractorId: contractor.id,
        config: [newConfig]
      });
    } catch (error) {
      console.error('Error updating credit config:', error);
    }
  };

  const generateKreditConfig = async () => {
    try {
      await axios.post(`https://bank2.daolog.net/api/generate-kredit-config`, {
        contractorId: contractor.id
      });
      alert('Конфігурацію кредиту успішно згенеровано');
    } catch (error) {
      console.error('Error generating kredit config:', error);
      alert('Помилка при генерації конфігурації кредиту');
    }
  };

  const getPackageDisplay = (packageValue) => {
    const packages = {
      'BASIC': translations.basic,
      'START': translations.start,
      'PRO': translations.pro,
      'EXCLUSIVE': translations.exclusive
    };
    return packages[packageValue] || 'Не вибрано';
  };

  // Get current package limit
  const getCurrentPackageLimit = () => {
    const currentPackage = getAvailablePackages().find(pkg => pkg.value === contractor?.pac);
    return currentPackage?.limit || 0;
  };

  const isLimitExceeded = currentFopCount >= getCurrentPackageLimit();

  if (loading) return <Typography>Завантаження...</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;

  const renderMainContent = () => {
    if (showSuccessContainer) {
      const isPackageUpdate = !extractData.fop && !extractData.edrpou;
      
      return (
        <div className="form-container">
          <h3>{isPackageUpdate ? 'Змінено пакет' : 'Додано нового контрагента'}</h3>
          <div>Дякуємо за Ваш вибір!</div>
          {isPackageUpdate ? (
            <>
              <div style={{marginTop: '20px', textAlign: 'center'}}>
              Поточний пакет застосується одразу, а перерахунок згідно нового пакету відбудеться автоматично за решту днів поточного місяця!
              </div>
              <div style={{marginTop: '20px', textAlign: 'center'}}>
                Відповідний запис у історії операції вже зроблено ;)
              </div>
            </>
          ) : (
            <>
              <div style={{marginTop: '20px', textAlign: 'center'}}>
                Операція з банківською випискою ФОП {extractData.fop},
              </div>
              <div> ЄДРПОУ {extractData.edrpou} вже доступні!</div>
              <div style={{marginTop: '20px', textAlign: 'center'}}>
                Відповідний запис у історії операції вже зроблено ;)
              </div>
            </>
          )}
          <div className="button-group">
            <button className="download-button-ch" onClick={handleClose}>Завершити</button>
          </div>
        </div>
      );
    }

    if (showChangeContractorForm) {
      return (
        <div className="form-container">
          <h3>Вкажіть поточного контрагента, якого плануєтеься "прибрати"</h3>
          <div className="fops-list">
            {contractorRestaurants
              .find(r => r.name === selectedRestaurant)?.fops
              .filter(fop => !fop.name_fop.includes('_deactivated'))
              .map((fop) => (
                <div key={fop.id}  style={{display: 'flex', alignItems: 'center', marginBottom: '5px'}}>
                  <Checkbox
                    checked={selectedFop === fop.id}
                    onChange={() => handleFopSelect(fop.id)}
                  />
                  <span style={{marginLeft: '5px', fontSize:"13px"}}>{fop.name_fop}</span>
                  {fop.del_date && <span style={{marginLeft: '10px'}}>Деактивовано: {new Date(fop.del_date).toLocaleDateString()}</span>}
                </div>
              ))}
          </div>
          {showWarning && (
            <div style={{marginTop: '20px', color: 'red'}}>
               ВАЖЛИВО: Повторно активувати контрагента знову можна буде не раніше ніж за 30 днів!
            </div>
          )}
          <div className="button-group">
            <button className="download-button" onClick={handleConfirmDeactivation}>Підтвердити</button>
            <button className="download-button" onClick={handleClose}>Закрити</button>
          </div>
        </div>
      );
    }

    if (showUploadForm || showAddForm) {
      if (showInvalidFopMessage) {
        return (
          <div className="form-container">
            <h3>Додано нового контрагента</h3>
            <div>Дякуємо за Ваш вибір!</div>
            <div style={{marginTop: '20px', textAlign: 'center'}}>
              Нажаль система автоматично не змогла активувати контрагента - але ми
              оперативно це зробимо вручну та одразу проінформуємо Вас
            </div>
            <div style={{marginTop: '20px', textAlign: 'center'}}>
              Відповідний запис у історії операції також буде зроблено
            </div>
            <div className="button-group">
              <Button onClick={handleClose}>Завершити</Button>
            </div>
          </div>
        );
      }
      
      return (
        <div className="form-container">
          <h3>Надайте витяг по контрагенту, якого бажаєте додати</h3>
          <input type="file" accept=".rtf" onChange={handleFileUpload} />
          <div className="button-group">
            <button className="download-button"
              onClick={handleConfirmFop}
              disabled={isLimitExceeded}
            >
              Зберегти
            </button>
            <button className="download-button" onClick={handleClose}>Закрити</button>
          </div>
          {isLimitExceeded && (
            <p className="status-message" style={{ color: 'red' }}>
              Ви досягли ліміту контрагентів для вашого пакету ({currentFopCount}/{getCurrentPackageLimit()})
            </p>
          )}
          {addFopStatus && <p className="status-message">{addFopStatus}</p>}
        </div>
      );
    }

    if (showPackageForm) {
      const selectedPacOption = getAvailablePackages().find(option => option.value === selectedPackage);
      const currentPacOption = getAvailablePackages().find(option => option.value === contractor?.pac);
      const isDowngrade = selectedPacOption?.limit < currentPacOption?.limit;

   
    }

    return (
      <div>
     
        
        <div className="credit-config-container" style={{ marginTop: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
          <h4>Налаштування комісії</h4>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
            <Checkbox
              checked={creditConfigActive}
              onChange={handleCreditConfigChange}
            />
            <span style={{ marginRight: '10px' }}>Активувати зміну ІПН якщо це комісія</span>
            <input
              type="text"
              value={creditConfig.edrpou}
              onChange={handleEdrpouChange}
              placeholder="Введіть ЄДРПОУ"
              style={{ padding: '5px', marginRight: '10px' }}
              disabled={!creditConfigActive}
            />
            <button 
              className="download-button" 
              onClick={generateKreditConfig}
              style={{ marginLeft: '10px' }}
            >
              Додати
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="main-content" style={{ marginTop: "90px" }}>
      <div className="header-info" style={{ textAlign: "center", marginBottom: "5px" }}>
        <h2 style={{ margin: "0 0 2px 0" }}>{translations.client}: {contractor?.name}</h2>
        {/* <p style={{ margin: "0", color:"grey" }}>{translations.pac}: {contractor?.pac ? getPackageDisplay(contractor.pac) : 'Не вибрано'}</p> */}
      </div>
      <div className="container-about-info-prof" style={{ marginTop: "20px" }}>
        {renderMainContent()}
      </div>
      {!showAddForm && !showPackageForm && !showChangeContractorForm && (
        <div className="header-info" style={{ textAlign: "center", marginBottom: "30px" }}>
        </div>
      )}
    </div>
  );
};

export default Fop;